(() => {
  if (window.pxFlashCopyReady) return;
  window.pxFlashCopyReady = true;
  document.addEventListener('click', async event => {
    const button = event.target.closest?.('[data-flash-copy]');
    if (!button || button.disabled) return;
    const offer = button.closest('.px-flash-offer');
    const status = offer.querySelector('.px-flash-copy-status');
    const label = button.querySelector('span');
    const code = button.dataset.flashCopy;
    button.disabled = true;
    let copied = false;
    try {
      if (navigator.clipboard?.writeText) { await navigator.clipboard.writeText(code); copied = true; }
    } catch { /* Use the selectable-code fallback below. */ }
    if (!copied) {
      const field = document.createElement('textarea');
      field.value = code; field.setAttribute('readonly','');
      field.style.cssText = 'position:fixed;top:0;left:-9999px;';
      document.body.append(field);field.select();
      try { copied = document.execCommand('copy'); } catch { copied = false; }
      field.remove();
    }
    button.disabled = false;
    button.focus({preventScroll:true});
    label.textContent = copied ? 'Copied' : 'Copy code';
    status.textContent = copied ? 'Code copied. Enter it at checkout.' : `Select and copy ${code} above, then enter it at checkout.`;
    if (copied) setTimeout(() => { if (button.isConnected) label.textContent = 'Copy code'; }, 2500);
  });
})();
